<template>
  <v-container
    fill-height
    :style="{ backgroundImage: 'url(' + bg + ')', backgroundPosition: 'center', backgroundSize: 'cover' }"
  >
    <v-layout align-center justify-center>
      <v-flex md6>
        <v-card class="pa-3">
          <v-card-text>
            <v-layout>
              <v-flex text-xs-center>
                <img :src="logo" height="200" style="width: 100%;" />
                <p>An online learning platform on thyroid disorders accessible for healthcare professionals in the Philippines.</p>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      logo: require('@/assets/svg/ELITE Logo.svg'),
      bg: require('@/assets/bg/water_3.png')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/home/slide1.vue